<template>
    <!--container-->
    <Row>
        <Row v-if="errorMessage" align="center">
            {{ $t('exam_in_progress', errorMessage) }}
        </Row>

        <v-row v-if="!errorMessage" align-content="center">
            <v-col align-content="center">
                <v-alert color="primary" type="info" class="text-start" prominent text>
                    {{ $t('loginLeftText') }}
                </v-alert>
            </v-col>
        </v-row>

        <v-row v-if="!errorMessage" align-content="center">
            <v-col align="center">
                <v-form @submit.prevent="login()">
                    <v-card tile max-width="max-content" min-width="30vw" class="card-login">
                        <v-card-title>
                            <v-spacer></v-spacer>
                            {{ $t('loginRightTitle') }}
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text >
                            <notifications class="" position="relative" group="userauth" />
                            <v-text-field ref="usernameInput" @focus.stop="onUsernameFocus" name="username"
                                v-model="username" :placeholder="$t('loginEmail')" />
                             
                            <v-text-field ref="passwordInput" @focus.stop="onPasswordFocus" v-model="password"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" :placeholder="$t('loginPass')">
                            </v-text-field>
                            <div>
                                <notifications position="bottom right" group="auth" />
                            </div>
                        </v-card-text>
                        <v-card-actions class="d-flex flex-column">
                            <v-row>
                                <v-col>
                                    <v-btn small tile color="primary" type="submit">
                                        {{ $t('loginButton') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <div v-if="!session.isExamApp()">
                                <v-col>
                                    <v-btn small tile color="primary" class="m-a-4">
                                        <a href="https://www.umfst.ro/fileadmin/ums/Ghid_schimbare_parola_email_institutional.pdf" style="color: unset;"
                                            target="_blank">
                                            {{ $t('changePasswordSteps') }}
                                        </a>
                                    </v-btn>
                                </v-col>
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>

        <v-sheet v-if="isKeyboardVisible && session.isExamApp()" class="keyboard-sheet">
            <v-btn icon @click="isKeyboardVisible = false">
                <v-icon size="28">mdi-chevron-down</v-icon>
            </v-btn>
            <SimpleKeyboard :input="currentFocusedInput == 'username' ? username : password" @onChange="onChange" />
        </v-sheet>
        <div v-if="session.isExamApp()" v-html="help"></div>

        <v-dialog
        :fullscreen="true"
        :scrollable="true"
        persistent
        v-model="chooseCollegedialogIsOpen"
        >
        <Card>
            <SelectCollege :showSelected="false"></SelectCollege> 
        </Card>
        </v-dialog>

    </Row>
</template>

<script>
import axios from "axios";
import { exam } from '@/js/exam';
import { session } from '@/js/session';
import '@/assets/main.css';
import { parse, stringify } from 'qs'
import SimpleKeyboard from '@/components/common/SimpleKeyboard.vue'
import SelectCollege from './SelectCollege.vue';
import { stopRecording } from '@/js/examRecord';

export default {
    name: 'Login',
    components: { SimpleKeyboard, SelectCollege },
    data() {
        return {
            username: "",
            password: "",
            showPassword: false,
            error: "",
            exam,
            session,
            parse,
            stringify,
            help: '',
            errorMessage: undefined,
            isKeyboardVisible: false,
            currentFocusedInput: "",
            chooseCollegedialogIsOpen : false
        }
    },
    computed: {
        buttonLabel() {
            return (this.showPassword) ? "Hide" : "Show";
        }
    },
    mounted() {
        if (localStorage.getItem("authenticated") == 'true') {
            this.$router.push({ name: 'Dashboard' });
        }
        this.help = this.$t('help');
    },
    methods: {
        onChange(input) {
            if (this.currentFocusedInput == "username") {
                this.username = input;
            } else if (this.currentFocusedInput == "password") {
                this.password = input;
            };
        },
        onUsernameFocus() {
            this.isKeyboardVisible = true
            this.currentFocusedInput = "username";
        },
        onPasswordFocus() {
            this.isKeyboardVisible = true
            this.currentFocusedInput = "password";
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        login() {

            //save prev recording if present 
            //stop any prev recording 
            stopRecording(this.$store);
            //clear local storage an session storage new login
            this.session.clearLocalStorageExceptTours();
            this.errorMessage = undefined;
            if (this.username != "" && this.password != "") {

                const params = {
                    Login: this.username,
                    Password: this.password
                };
                axios({
                    "async": true,
                    "crossDomain": true,
                    url: process.env.VUE_APP_ROOT_API + 'login/',
                    method: 'get',
                    params: params,

                }).then(response => {
                    if (response.data) {
                        if (response.data.error != null && response.data.error == 49) {

                            this.$notify({
                                group: 'userauth',
                                type: 'error',
                                text: '<strong>Attention!</strong> Invalid credentials.',
                                duration: -1
                            });

                            this.error = 'The username and / or password is incorrect';
                        }
                        else if (response.data.error != null && response.data.error == 81) {
                            this.$notify({
                                group: 'auth',
                                type: 'error',
                                text: 'The server is unavaible. Please try again later!'
                            });
                        }
                        else if (response.data.error != null && response.data.error == 'exam_in_progress') {
                            this.errorMessage = response.data;
                        }
                        else if (response.data.error != null) {
                            this.$notify({
                                group: 'userauth',
                                type: 'error',
                                text: '<strong>Attention!</strong> Invalid credentials.',
                                text: response.data.error
                            });
                        }
                        else {
                            if(response.data)
                            this.session.setupLogin(response.data);
                            if(this.session.hasStudentMultipleCollege()){
                                //show modal
                                this.chooseCollegedialogIsOpen=true;
                            }else{
                                this.session.replaceRouter("Dashboard");
                                location.reload();
                            }
                        }
                    }
                    else {
                        this.$notify({
                            group: 'auth',
                            type: 'error',
                            text: 'The username and / or password is incorrect'
                        });


                    }

                }).catch(() => {

                });
            } else {
                this.$notify({
                    group: 'auth',
                    type: 'error',
                    text: 'A username and password must be present'
                });
            }
        },
        onChangeUser(input) {
            this.input.username = input;
        },
        onKeyPressUser(button) {
            //console.log("button", button);
        },
        onInputChangeUser(input) {
            if (input.target) {
                this.input.username = input.target.value;
            }
        },
        onChangePass(input) {
            this.input.password = input;
        },
        onKeyPressPass(button) {
            // console.log("button", button);
        },
        onInputChangePass(input) {
            if (input.target) {
                this.input.password = input.target.value;
            }
        }
    }
}
</script>

<style>
#login .form-inputs {
    padding-bottom: 10px;
}

#login .form-inputs label {
    padding-right: 10px;
}

.warning {
    color: red;
    font-size: 12px;
}

.keyboard-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 0;
    padding-bottom: 60px;
}

</style>